'use strict';

/*
 * Filter to return Review State
 * Usage: Content status: {{ isApproved | ReviewFilter }}
 */
DoohApps.filter('ReviewFilter', function () {
    return function (isApproved) {
        switch (isApproved) {
            case true:
                return 'Approved';
            case false:
                return 'Rejected';
            default:
                return 'Waiting for Approval';
        }
    }
});